// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"198781e8","71":"2e11a232","268":"b7a4f5f4","453":"f03b7ee1","457":"a2a870bf","536":"91c035a2","548":"0ddae46b","551":"104e0900","828":"8ddfc212","849":"140b9321","950":"70753865"}[chunkId] + ".chunk.js";
};